package org.gstechnovos.jexonplastech.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.anyLink
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.selectors.link
import com.varabyte.kobweb.silk.style.selectors.visited
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.util.Constants
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.filter
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val NavigationItemStyle = CssStyle {
    // 1. Base (Layout & Transitions only)
    base {
        Modifier
            .fontFamily(Constants.FONT_FAMILY)
            .fontSize(18.px)
            .fontWeight(FontWeight.Normal)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }

    // 2. The "Catch-All" for Link States
    // We use cssRule(":any-link") to target both visited and unvisited links
    // This overrides the default Blue/Underline
    cssRule(":any-link") {
        Modifier.styleModifier {
            property("color", "${Theme.Secondary.hex} !important")
            property("text-decoration", "none !important")
        } // Crucial: Define this HERE, not in base
    }

    // 3. Hover State
    hover {
        Modifier.styleModifier {
            // Add !important here too, otherwise the base rule wins
            property("color", "${Theme.Primary.hex} !important")
            property("text-decoration", "none !important")
        }
    }
}

val LogoStyle = CssStyle {
    base {
        Modifier.transform { rotate(0.deg) }.transition(Transition.of(property = "transform", duration = 200.ms))
    }
    hover {
        Modifier.transform { rotate((-10).deg) }
    }
}

val SocialLinkStyle = CssStyle {
    base {
        Modifier.color(Theme.Gray.rgb).transition(
            Transition.of(property = "color", duration = 200.ms)
        )
    }
    hover{
        Modifier.color(Theme.Primary.rgb)
    }
}

val MainButtonStyle = CssStyle {
    base {
        Modifier.width(100.px).transition { Transition.of(property = "width", duration = 200.ms) }
    }
    hover{
        Modifier.width(125.px)

    }
}

@OptIn(ExperimentalComposeWebApi::class)
val MainImageStyle = CssStyle {
    base {
        Modifier.styleModifier {
            filter {
                grayscale(100.percent)
            }
        }.transition { Transition.of(property = "filter", duration = 200.ms) }
    }
    hover{
        Modifier.styleModifier {
            filter {
                grayscale(0.percent)
            }
        }
    }
}